/** Chromium-style output routing; absent on many Safari / iOS WebView builds. */
export function browserSupportsSetSinkId(): boolean {
  return (
    typeof HTMLMediaElement !== "undefined" &&
    "setSinkId" in HTMLMediaElement.prototype
  );
}

export async function applyMediaSinkId(
  element: HTMLMediaElement | null,
  sinkId: string,
): Promise<void> {
  if (!element) {
    return;
  }
  const el = element as HTMLMediaElement & {
    setSinkId?: (id: string) => Promise<void>;
  };
  if (typeof el.setSinkId !== "function") {
    return;
  }
  await el.setSinkId(sinkId);
}
